var FN = (function () {

  // ── CART DRAWER ──────────────────────────────────────────
  function openCart() {
    document.getElementById('cart-drawer').classList.add('open');
    document.getElementById('cart-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    document.getElementById('cart-drawer').classList.remove('open');
    document.getElementById('cart-overlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  // ── ADD TO CART (Shopify Ajax API) ───────────────────────
  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    var properties = {};
    var propsAttr = btn.getAttribute('data-properties');
    if (propsAttr) {
      try { properties = JSON.parse(propsAttr); } catch(e) {}
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      refreshCart();
      openCart();
      btn.textContent = 'Add to Bag';
      btn.disabled = false;
    })
    .catch(function (err) {
      console.error('Add to cart error:', err);
      btn.textContent = 'Error — try again';
      btn.disabled = false;
    });
  }

  // ── REMOVE ITEM ──────────────────────────────────────────
  function removeItem(btn) {
    var key = btn.getAttribute('data-key');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (res) { return res.json(); })
    .then(function () { refreshCart(); })
    .catch(function (err) { console.error('Remove error:', err); });
  }

  // ── REFRESH CART DRAWER HTML ─────────────────────────────
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      updateCartTotal(cart.total_price);
      renderCartItems(cart.items);
    })
    .catch(function (err) { console.error('Cart refresh error:', err); });
  }

  function updateCartCount(count) {
    var el = document.getElementById('cart-count');
    if (el) el.textContent = count;
  }

  function updateCartTotal(totalCents) {
    var el = document.getElementById('cart-total');
    if (el) el.textContent = formatMoney(totalCents);
  }

  function renderCartItems(items) {
    var bodyEl = document.getElementById('cart-body');
    var emptyEl = document.getElementById('cart-empty');
    var footEl  = document.getElementById('cart-foot');
    var itemsEl = document.getElementById('cart-items');

    if (!bodyEl) return;

    if (items.length === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      if (footEl)  footEl.style.display  = 'none';
      if (itemsEl) itemsEl.innerHTML = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footEl)  footEl.style.display  = 'block';

    if (!itemsEl) return;
    itemsEl.innerHTML = items.map(function (item) {
      var imgTag = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '';
      var variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title + (item.quantity > 1 ? ' &middot; Qty ' + item.quantity : '')
        : (item.quantity > 1 ? 'Qty ' + item.quantity : '');
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-item-img">' + imgTag + '</a>' +
        '<div class="cart-item-details">' +
          '<div class="cart-item-name">' + escapeHtml(item.product_title) + '</div>' +
          (variantLabel ? '<div class="cart-item-meta">' + variantLabel + '</div>' : '') +
          '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button class="cart-remove" data-key="' + item.key + '" onclick="FN.removeItem(this)">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  // ── PRODUCT PAGE: SIZE SELECTION ─────────────────────────
  function selectOption(btn) {
    var optionName  = btn.getAttribute('data-option');
    var optionValue = btn.getAttribute('data-value');

    // Visually activate within the group
    btn.closest('.size-grid').querySelectorAll('.size-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');

    // Track selected option
    if (window.FN_PRODUCT) {
      window.FN_PRODUCT.selectedOptions[optionName] = optionValue;
      matchVariant();
    }
  }

  function matchVariant() {
    var product   = window.FN_PRODUCT;
    var variants  = product.variants;
    var selected  = product.selectedOptions;
    var atcBtn    = document.getElementById('atc-btn');
    var priceEl   = document.getElementById('product-price');

    var matched = variants.find(function (v) {
      return Object.keys(selected).every(function (optName) {
        return v['option' + getOptionIndex(optName)] === selected[optName];
      });
    });

    if (!matched) return;

    atcBtn.setAttribute('data-variant-id', matched.id);

    if (matched.available) {
      atcBtn.disabled     = false;
      atcBtn.textContent  = 'Add to Bag';
    } else {
      atcBtn.disabled     = true;
      atcBtn.textContent  = 'Sold Out';
    }

    if (priceEl && matched.price) {
      priceEl.textContent = formatMoney(matched.price);
    }

    // Update URL without reload
    var url = new URL(window.location.href);
    url.searchParams.set('variant', matched.id);
    window.history.replaceState({}, '', url.toString());
  }

  function getOptionIndex(name) {
    if (!window.FN_PRODUCT) return 1;
    var variants = window.FN_PRODUCT.variants;
    if (!variants.length) return 1;
    var v = variants[0];
    // Shopify variants have option1/option2/option3 but no names directly
    // We rely on the product options order set in selectOption data attributes
    var opts = document.querySelectorAll('.variant-group .size-label');
    var idx  = 1;
    opts.forEach(function (el, i) {
      if (el.textContent.trim() === name) idx = i + 1;
    });
    return idx;
  }

  // ── GALLERY: SWITCH IMAGE ────────────────────────────────
  function switchImage(src, btn) {
    var mainImg = document.querySelector('.product-main-img img');
    if (mainImg) {
      mainImg.style.opacity = '0';
      setTimeout(function () {
        mainImg.src = src;
        mainImg.style.opacity = '1';
      }, 150);
    }
    document.querySelectorAll('.product-thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    btn.classList.add('active');
  }

  // ── HELPERS ──────────────────────────────────────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── INIT ─────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    // Keyboard close for cart
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });
  });

  return {
    openCart:    openCart,
    closeCart:   closeCart,
    addToCart:   addToCart,
    removeItem:  removeItem,
    selectOption: selectOption,
    switchImage:  switchImage,
    refreshCart:  refreshCart,
  };

})();
